import React, { useEffect, useContext } from 'react';
import { string, shape, bool } from 'prop-types';
import classNames from 'classnames';
import { Carousel } from '@thd-olt-component-react/carousel';
import { Col, Row } from '@thd-olt-component-react/grid';
import {
  arrayOf as arrayOfType,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useSearchDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { RentalIntentPod } from './RentalIntentPod';
import { RentalIntentNoResults } from './RentalIntentNoResults';
import styles from '../styles/rental-intent.module.scss';

const RentalIntent = (props) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('rental-intent.ready'); }, []);

  const {
    keyword
  } = props;

  // eslint-disable-next-line react/destructuring-assignment
  const isControlledData = typeof props.data !== 'undefined' || typeof props.loading !== 'undefined';

  const skipSearch = isControlledData || !keyword;

  const { channel } = useContext(ExperienceContext);

  const domains = [
    'orangeGraph',
  ];

  const searchResponse = useSearchDeprecated({
    domains,
    keyword,
    skip: skipSearch
  });

  let data;

  // eslint-disable-next-line react/destructuring-assignment
  if (typeof props.data !== 'undefined') {
    ({ data } = props);
  } else {
    ({ data } = searchResponse);
  }

  const { intents, universalSearchArray, productTypes } = data?.searchModel?.orangeGraph || {};
  const { correctedKeyword } = data?.searchModel?.searchReport || '';

  const title = correctedKeyword || keyword;

  if (!intents?.includes('rental')) return null;

  if (universalSearchArray.length === 0) return null;

  const { pods } = universalSearchArray[0];
  const rentalPods = pods
    .filter((pod) => pod?.recordType?.toUpperCase()?.includes('RENTAL'));

  if (rentalPods.length === 0) return <RentalIntentNoResults productTypes={productTypes} />;

  return (
    <Row className={classNames(styles['rental-intent'])}>
      <Col fallback="12" nopadding>
        <div className={classNames(styles['rental-intent__header'])}>
          <div className={classNames(styles['rental-intent__header-title'])}>
            <span className={classNames(styles['rental-intent__header-text'])}>{title}</span>
          </div>
        </div>
        {channel === 'mobile' ? (
          <div className={classNames(styles['rental-intent-pods'])}>
            {rentalPods.map((pod, index) => (
              <RentalIntentPod
                key={`${'rental-intent-pod-' + index}`}
                index={index}
                title={pod.title}
                description={pod.description}
                link={pod.link}
                imageUrl={pod.imageUrl}
              />
            ))}
          </div>
        ) : (
          <Carousel
            itemWidthDesktop="25%"
            itemClass={classNames(styles['rental-intent-pod__wrapper'])}
          >
            {rentalPods.map((pod, index) => (
              <RentalIntentPod
                key={`${'rental-intent-pod-' + index}`}
                index={index}
                title={pod.title}
                description={pod.description}
                link={pod.link}
                imageUrl={pod.imageUrl}
              />
            ))}
          </Carousel>
        )}
      </Col>
    </Row>
  );
};

RentalIntent.displayName = 'RentalIntent';

RentalIntent.propTypes = {
  keyword: string,
  data: shape({}),
  loading: bool,
};

RentalIntent.defaultProps = {
  keyword: '',
  data: undefined,
  loading: undefined
};

RentalIntent.dataModel = {
  searchModel: params({
    keyword: stringType()
  }).shape({
    id: stringType(),
    orangeGraph: shapeType({
      universalSearchArray: arrayOfType({
        pods: arrayOfType({
          title: stringType(),
          description: stringType(),
          imageUrl: stringType(),
          link: stringType(),
          recordType: stringType()
        })
      }),
      intents: arrayOfType(stringType()),
      productTypes: arrayOfType(stringType())
    }),
    searchReport: shapeType({
      correctedKeyword: stringType()
    })
  })
};

export { RentalIntent };
